import React from 'react';

/** Pan with steam and spatula — "Preparing" step (matches customer-facing prep icon). */
function OrderPreparingIcon({ className, ...props }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M8.25 4.25c0 1.35-.55 2.2-.85 3.35M12 3.25v4.9M15.75 4.25c0 1.35.55 2.2.85 3.35"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M6.25 10.75 11.25 15.25"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M11.25 15.25h2.85c.75 0 1.35-.6 1.35-1.35v-.15c0-.45-.25-.9-.65-1.15l-3.55-2.6"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 14.75h12.75c1.9 0 3.5 1.6 3.5 3.5v.75H4.75v-.75c0-1.9 0-3.5 0-3.5Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 15.25h2.25"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default OrderPreparingIcon;
